import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// @ts-ignore Ignore unused commented AuthGuard import
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { AgrPageModule, AgrPrimaryActionModule } from '@next/core-lib/components';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { DevAuthComponent } from './dev-auth.component';
import { SharedModule } from '../shared/shared.module';

import { DevAuthEffects } from './store/effects/dev-auth.effects';
import { devAuthReducer } from './store/reducers/dev-auth.reducers';

@NgModule({
  declarations: [DevAuthComponent],
  imports: [
    CommonModule,
    SharedModule,
    AgrPageModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    AgrPrimaryActionModule,
    MatInputModule,
  ],
  providers: [provideState('devAuthModule', devAuthReducer), provideEffects([DevAuthEffects])],
})
export class DevAuthModule {}
